



















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import {
  User,
  Role,
  TeamReviewSettings,
  ConfigureReviewerEnum,
  TeamReviewers,
  TeamReviewees
} from "../../types";
import autocomplete from "@/components/review/AutoComplete.vue";
import autocompleteFormTags from "@/components/review/AutoCompleteFormTags.vue";
import Trash from "@/assets/images/icons/trash.svg?inline";
import { updateTeamReviewSettings } from "@/api.ts";
const vClickOutside = require("v-click-outside");

@Component({
  components: {
    autocomplete,
    autocompleteFormTags,
    Trash
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
})
export default class ConfigureReviewersCustom extends Vue {
  @Getter private JWT!: string;
  @Getter private currentTeamUsers?: User[];
  @Getter private teamReviewSettings?: TeamReviewSettings;
  @Getter private currentTeamID!: string;
  @Action private setDisplayError: any;
  @Action private setTeamReviewSettings!: any;

  private teamReviewSettingsApi?: TeamReviewSettings;
  private reviewerManagerUsers?: User[];
  private users?: User[];
  private reviewerManagerUsersString?: string[];
  private reviewerUsersString?: string[];
  private editingReviewerIndex: number = -1;

  private updateTimer?: number;

  private reviewersRandom = 1;
  private isShowTooltip = false;
  private tooltip =
    "Users with either manager or reviewer roles can be added here";

  private created() {
    this.reviewersRandom = 1;
    this.copyObject();
  }

  @Watch("teamReviewSettings", { immediate: true })
  private onTeamReviewSettings() {
    if (this.teamReviewSettings) {
      this.teamReviewSettings.method = ConfigureReviewerEnum.Custom;
    }
    this.copyObject();
  }

  private onFilterEmptyReviewers() {
    this.editingReviewerIndex = -1;
    if (this.teamReviewSettings) {
      let reviewersFiltered = this.teamReviewSettings.reviewers.filter(
        (reviewer: TeamReviewers) => {
          return (
            reviewer.uid !== null &&
            reviewer.uid.length > 0 &&
            reviewer.name !== null &&
            reviewer.name.length > 0
          );
        }
      );

      if (
        this.teamReviewSettings.reviewers.length !== reviewersFiltered.length
      ) {
        this.teamReviewSettings.reviewers = reviewersFiltered;
      }
    }
  }

  get reviewersFilteredList() {
    if (
      this.teamReviewSettings &&
      this.teamReviewSettings.teamUsers.length > 0
    ) {
      let reviewers = this.teamReviewSettings.reviewers;
      let teamUsers = this.teamReviewSettings.teamUsers;

      return teamUsers.filter(
        teamUser =>
          reviewers.findIndex(
            (reviewer, i) =>
              i !== this.editingReviewerIndex && teamUser.uid === reviewer.uid
          ) === -1 &&
          (teamUser.role === Role.Reviewer || teamUser.role === Role.Manager)
      );
    } else {
      return [];
    }
  }

  get reviewerFilteredListNames() {
    return this.reviewersFilteredList.map(users => ({
      uid: users.uid,
      name: users.name
    }));
  }

  get revieweesUsers() {
    if (
      this.teamReviewSettings &&
      this.editingReviewerIndex > -1 &&
      this.teamReviewSettings.teamUsers.length > 0
    ) {
      let reviewer = this.teamReviewSettings.reviewers[
        this.editingReviewerIndex
      ];
      let teamUsers = this.teamReviewSettings.teamUsers.filter(
        teamUser =>
          reviewer.reviewees.findIndex(
            reviewee => teamUser.uid === reviewee.uid
          ) === -1
      );

      return teamUsers.filter(
        teamUser =>
          teamUser.uid !== reviewer.uid &&
          (teamUser.role === Role.Reviewer || teamUser.role === Role.User)
      );
    } else {
      return [];
    }
  }
  get revieweesFilteredNames() {
    return this.revieweesUsers.map(users => {
      return users.name;
    });
  }

  private revieweesSelectedNames(index: number) {
    if (
      this.teamReviewSettings &&
      this.teamReviewSettings.reviewers.length > 0
    ) {
      return this.teamReviewSettings.reviewers[index].reviewees.map(users => {
        return users.name;
      });
    } else {
      return [];
    }
  }

  private revieweesSelected(index: number) {
    if (
      this.teamReviewSettings &&
      this.teamReviewSettings.reviewers.length > 0
    ) {
      return this.teamReviewSettings.reviewers[index].reviewees;
    } else {
      return [];
    }
  }

  private deleteReviewer(index: number) {
    if (this.teamReviewSettings) {
      let reviewers = this.teamReviewSettings.reviewers;
      reviewers.splice(index, 1);
      this.teamReviewSettings.reviewers = reviewers;
      //this.updateTeamReviewSettings();
    }
  }

  private addReviewer(event: Event) {
    event.stopPropagation();
    if (this.teamReviewSettings) {
      this.teamReviewSettings.reviewers.push({
        uid: "",
        name: "",
        reviewees: []
      });
      this.editingReviewerIndex = this.teamReviewSettings.reviewers.length - 1;
    }
  }

  private onTeamReviewChanges() {
    this.onFilterEmptyReviewers();

    if (this.isSettingsDataChanged) {
      this.updateTeamReviewSettings();
    }
  }

  get isSettingsDataChanged() {
    return (
      JSON.stringify(this.teamReviewSettings) !==
      JSON.stringify(this.teamReviewSettingsApi)
    );
  }

  private updateTeamReviewSettings() {
    if (this.teamReviewSettings) {
      updateTeamReviewSettings(
        this.JWT,
        this.currentTeamID,
        this.teamReviewSettings,
        (teamReviewSettings: TeamReviewSettings) => {
          this.setTeamReviewSettings(teamReviewSettings);
          this.copyObject();
          this.showSuccessToast();
        },
        (error: string) => {
          this.setDisplayError(error);
        }
      );
    }
  }

  private showSuccessToast() {
    this.$bvToast.toast("Settings updated", {
      noCloseButton: true,
      variant: "success",
      autoHideDelay: 2000,
      solid: true
    });
  }

  private copyObject() {
    this.teamReviewSettingsApi = JSON.parse(
      JSON.stringify(this.teamReviewSettings)
    );
  }

  private editReviewerItem(event: Event, index: number) {
    event.stopPropagation();
    this.editingReviewerIndex = index;
  }

  private onReviewerSelected(uid: string) {
    let reviewer = this.reviewersFilteredList.filter(
      reviewer => reviewer.uid === uid
    );
    if (this.teamReviewSettings && reviewer && reviewer.length > 0) {
      let editedReview = this.teamReviewSettings.reviewers[
        this.editingReviewerIndex
      ];
      editedReview.uid = reviewer[0].uid;
      editedReview.name = reviewer[0].name;
      this.teamReviewSettings.reviewers[
        this.editingReviewerIndex
      ] = editedReview;
      this.editingReviewerIndex = -1;
    }
  }

  private onUsersSelected(uid: string) {
    let revieweeUser = this.revieweesUsers.filter(
      reviewee => reviewee.uid === uid
    );
    if (this.teamReviewSettings && revieweeUser && revieweeUser.length > 0) {
      this.teamReviewSettings.reviewers[
        this.editingReviewerIndex
      ].reviewees.push(revieweeUser[0]);
      this.editingReviewerIndex = -1;
    }
  }

  private onUsersRemoved(uid: string) {
    if (this.teamReviewSettings) {
      let userIndex = this.teamReviewSettings.reviewers[
        this.editingReviewerIndex
      ].reviewees.findIndex(reviewee => reviewee.uid === uid);
      if (userIndex > -1) {
        this.teamReviewSettings.reviewers[
          this.editingReviewerIndex
        ].reviewees.splice(userIndex, 1);
      }
    }
  }

  get allReviewersList() {
    if (this.teamReviewSettings) {
      return this.teamReviewSettings.teamUsers.filter(
        teamUser =>
          teamUser.role === Role.Reviewer || teamUser.role === Role.Manager
      );
    } else {
      return [];
    }
  }

  get allReviewersCount() {
    return this.allReviewersList.length;
  }

  private distributeRandom() {
    if (this.teamReviewSettings) {
      let reviewersList = this.allReviewersList;

      let usersList = this.teamReviewSettings.teamUsers.filter(
        teamUser => teamUser.role === Role.User
      );

      let postUserList = usersList;
      postUserList.sort(() => Math.random() - 0.5);

      for (var i = 0; i < this.reviewersRandom - 1; i++) {
        usersList.sort(() => Math.random() - 0.5);
        postUserList = postUserList.concat(usersList);
      }
      reviewersList.sort(() => Math.random() - 0.5);

      if (reviewersList.length > 0) {
        this.teamReviewSettings.reviewers = [];
        var randomUsers = this.chunkArray(postUserList, reviewersList.length);

        for (let [index, reviewer] of reviewersList.entries()) {
          this.teamReviewSettings.reviewers.push({
            uid: reviewersList[index].uid,
            name: reviewersList[index].name,
            reviewees: randomUsers[index]
          });
        }
      }
    }
  }

  private chunkArray(arr: any[], chunkCount: number) {
    const chunks = [];
    while (arr.length) {
      const chunkSize = Math.ceil(arr.length / chunkCount--);
      const chunk = arr.slice(0, chunkSize);
      chunks.push(chunk);
      arr = arr.slice(chunkSize);
    }
    return chunks;
  }

  private randomReviewerUpdate() {
    
    if (this.reviewersRandom > this.allReviewersCount) {
      this.reviewersRandom = this.allReviewersCount;
      return false;
    }
  }

  private allowOnlyNumbers(event:any) {
    
    var keycode = event.which;
    if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57)))) {
        event.preventDefault();
    }
  }
}
